// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Hint_wrapper__2oakW","hints":"Hint_hints__2Z58H","maxHeight300":"Hint_maxHeight300__biSzA","active-hint":"Hint_active-hint__1o8BH","hint":"Hint_hint__3yOzv"};